module.exports = __webpack_public_path__ + "static/media/munin-happy.1c236c9c.svg";